import { useEffect } from "react";
import "./Contact.css";

import Navbar from "../Navbar/Navbar";
import Footer from "../Home/Components/footer/Footer";

const Contact = () => {

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "auto" });
    }, []);

    return (

        <>

            <Navbar />

            <div id="contact" className="partFour">


                <div className="am-1 contact-header" >
                    {/* <h4>Your child's <span>holistic journey</span> begins here</h4> */}
                    <h2><span>Reach</span> out to us</h2>
                </div>

                <div className="contactUsDiv">

                    <div className="contactPartOneMain" >

                        {/* Contact details */}
                        <div className="contactPartOne">
                            {/* <h3>Get in touch</h3> */}

                            <div className="contactPartOneSub" >
                                <div className="contact-icons">
                                    <i style={{ fontSize: "25px" }} className="fa-solid fa-phone"></i>
                                </div>
                                <div className="c-info" >
                                    <p style={{ fontWeight: "bold", fontSize: "20px" }} className="contactP" >Phone :</p>
                                    <p >+91 9246182801</p>
                                </div>
                            </div>

                            <div className="contactPartOneSub" >
                                <div className="contact-icons">
                                    <i style={{ fontSize: "25px" }} className="fa-solid fa-envelope"></i>
                                </div>
                                <div className="c-info" >
                                    <p style={{ fontWeight: "bold", fontSize: "20px" }} className="contactP" >Email :</p>
                                    <p >info@anubhavamontessori.com</p>
                                </div>
                            </div>

                            <div className="contactPartOneSub" style={{ height: "120px" }} >
                                <div className="contact-icons">
                                    <i className="fa-solid fa-location-crosshairs"></i>
                                </div>
                                <div className="c-info" >
                                    <p style={{ fontWeight: "bold", fontSize: "20px" }} className="contactP" >Location :</p>
                                    <p >5-8-296, Fateh Maidan Lane <br /> Beside Seven Eleven Bakery <br /> Abids, Hyderabad</p>
                                </div>
                            </div>

                        </div>

                        {/* Contact form */}

                        <div className="contactForm">

                            <div className="contactPartTwo">
                                <iframe title="map" className="contact-map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3807.40289023752!2d78.47031637493481!3d17.392442383495595!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9762d306b69d%3A0xb07012f2a42df81c!2sAnubhava%20Montessori%20-%20House%20of%20Children!5e0!3m2!1sen!2sin!4v1755440073256!5m2!1sen!2sin" width="600" style={{ border: "0", height: "40vh", borderRadius: "10px" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                            </div>

                        </div>

                    </div>

                </div>

            </div>

            <Footer />

        </>
    )

}

export default Contact